import { render, staticRenderFns } from "./synchroinvoice.vue?vue&type=template&id=87ce1354&scoped=true&"
import script from "./synchroinvoice.vue?vue&type=script&lang=js&"
export * from "./synchroinvoice.vue?vue&type=script&lang=js&"
import style0 from "./synchroinvoice.vue?vue&type=style&index=0&id=87ce1354&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ce1354",
  null
  
)

export default component.exports